module.exports = function() {
  return new Worker(__webpack_public_path__ + "68f6c6c0bf761ff78f4c.worker.js");
};